import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import type { EventFormEventData, FieldError } from './shared'

export default function FundraisingProgressFields({
  value,
  onChange,
  fieldError,
}: {
  value: EventFormEventData
  onChange: (next: EventFormEventData) => void
  fieldError: FieldError
}) {
  if (!value.donations_enabled) {
    return (
      <p className="text-sm text-muted-foreground">
        Enable donations to show a fundraising progress bar on the public page.
      </p>
    )
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Switch
          id="show_donation_progress"
          checked={value.show_donation_progress}
          onCheckedChange={(checked) => onChange({ ...value, show_donation_progress: checked })}
        />
        <Label htmlFor="show_donation_progress">Show fundraising progress on the public page</Label>
      </div>
      {fieldError('show_donation_progress') && (
        <p className="text-base text-destructive">{fieldError('show_donation_progress')}</p>
      )}
      {value.show_donation_progress && (
        <div className="space-y-2">
          <Label htmlFor="donation_goal_dollars">Fundraising goal</Label>
          <div className="relative">
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">$</span>
            <Input
              id="donation_goal_dollars"
              type="number"
              min="1"
              step="1"
              className="pl-7"
              value={value.donation_goal_dollars}
              onChange={(event) => onChange({ ...value, donation_goal_dollars: event.target.value })}
              placeholder="10000"
            />
          </div>
          {fieldError('donation_goal_cents') ? (
            <p className="text-xs text-destructive">{fieldError('donation_goal_cents')}</p>
          ) : (
            <p className="text-xs text-muted-foreground">
              The progress bar appears on your public page once a goal is set.
            </p>
          )}
        </div>
      )}
    </div>
  )
}
